import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { commonPath } from '../fieldPath';
import { PCPDUrationUnit } from '../../../Components/helper';

function DependentAccordian({ cardEle, cardIndex, handleChange, modalState, addEditAccess }) {
  const { t } = useTranslation('common');

  return (
    <div className="collapse-card add-bom-accordion">
      <Accordion key={`Column_${cardIndex}`}>
        <Card className="bom-add-card ">
          <Card.Header className="bgcolor-dark rounded-0 ">
            <div className=" align-items-center reducing-switch-z-index mr-16">
              <div className="d-inline-flex align-items-center design-switch">
                <input
                  type="checkbox"
                  className="form-check-input comment-switch-input"
                  id={`dependent_${cardIndex}`}
                  name={`dependent_${cardIndex}`}
                  checked={cardEle?.dependentObj?.dependentSwitch}
                  onChange={(e) =>
                    !e?.target?.checked
                      ? handleChange(e?.target?.checked, commonPath(cardIndex, 'dependentObj.dependentSwitch').COMMON, cardIndex, [
                          'dependentObj',
                          'customDurations',
                        ])
                      : handleChange(e?.target?.checked, commonPath(cardIndex, 'dependentObj.dependentSwitch').COMMON, cardIndex)
                  }
                  disabled={cardEle?.colorSwitch || cardEle?.durationCounterSwitch}
                />
                <label className="switch-text font-heavy align-items-center mt-03" htmlFor={`dependent_${cardIndex}`}>
                  {t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.DEPENDENT_SWITCH')}
                </label>
              </div>
            </div>

            <Accordion.Toggle className="btn-toggle text-decoration-none text-dark" as="button" variant="link">
              <i className="icon-new-down-arrow-icon " />
            </Accordion.Toggle>
          </Card.Header>
          {cardEle?.dependentObj?.dependentSwitch && (
            <Card.Body>
              <div className="flex-fill ">
                <p className="custom-radio mb-2">
                  <input
                    type="radio"
                    id={`Before_${cardIndex}`}
                    name={`Before_${cardIndex}`}
                    checked={!cardEle?.dependentObj?.futureDependent}
                    onChange={(e) =>
                      handleChange(!e?.target?.checked, commonPath(cardIndex, 'dependentObj.futureDependent').COMMON, cardIndex, ['dependentObj,durationValue'])
                    }
                    disabled={!addEditAccess}
                  />
                  <label htmlFor={`Before_${cardIndex}`}>{t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.BEFORE')}</label>
                </p>
                <p className="custom-radio mb-2">
                  <input
                    type="radio"
                    id={`After_${cardIndex}`}
                    name={`After_${cardIndex}`}
                    checked={cardEle?.dependentObj?.futureDependent}
                    onChange={(e) =>
                      handleChange(e?.target?.checked, commonPath(cardIndex, 'dependentObj.futureDependent').COMMON, cardIndex, ['dependentObj.durationValue'])
                    }
                    disabled={!addEditAccess}
                  />
                  <label htmlFor={`After_${cardIndex}`}>{t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.AFTER')}</label>
                </p>
                <div className="common-react-select">
                  <p className="field-name">{t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.COLUMN')}</p>
                  <Select
                    name="dependentColumn"
                    options={modalState?.dateTypeColumn}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    maxMenuHeight={140}
                    menuPosition="fixed"
                    value={cardEle?.dependentObj?.dependentColumn}
                    className="common-select"
                    classNamePrefix="common-select"
                    isClearable
                    onChange={(e) => handleChange(e, commonPath(cardIndex, 'dependentObj.dependentColumn').COMMON, cardIndex)}
                    placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.SELECT_COLUMN')}
                    isDisabled={!addEditAccess}
                    menuPlacement="bottom"
                    menuShouldBlockScroll
                    menuShouldScrollIntoView
                  />
                  {cardEle.hasError && !cardEle?.dependentObj?.dependentColumn && (
                    <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.COLUMN_SELECTION_REQUIRED')}</span>
                  )}
                </div>
              </div>
              <div className="d-flex mt-2">
                <div className="common-input-control">
                  <p className="field-name">
                    {t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.DURATION_QUANTITY')}
                    <span className="asterisk">*</span>
                  </p>
                  <input
                    type="number"
                    name="durationQuantity"
                    value={cardEle?.dependentObj?.durationValue}
                    disabled={!addEditAccess}
                    placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.DURATION_QUANTITY')}
                    onChange={(e) => {
                      if (/^\s*$|^[1-9]\d*$/.test(e?.target?.value)) {
                        handleChange(e?.target?.value, commonPath(cardIndex, 'dependentObj.durationValue').COMMON, cardIndex);
                      }
                    }}
                    className="form-control"
                  />
                  {cardEle.hasError && !cardEle?.dependentObj?.durationValue && (
                    <span className="error-message d-block">{t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.DEPENDENT_VALUE_REQUIRED')}</span>
                  )}
                </div>
                <div className="flex-fill w-50 ml-2">
                  <div className="common-react-select">
                    <p className="field-name">{t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.DURATION_UNIT')}</p>
                    <Select
                      name="durationUnit"
                      options={PCPDUrationUnit}
                      getOptionLabel={(option) => `${option.label}`}
                      getOptionValue={(option) => `${option.name}`}
                      maxMenuHeight={140}
                      menuPosition="fixed"
                      value={cardEle?.dependentObj?.durationUnit}
                      className="common-select"
                      classNamePrefix="common-select"
                      isClearable
                      onChange={(e) => handleChange(e, commonPath(cardIndex, 'dependentObj.durationUnit').COMMON, cardIndex)}
                      placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.SELECT_DURATION_UNIT')}
                      disabled={!addEditAccess}
                      menuPlacement="bottom"
                      menuShouldBlockScroll
                      menuShouldScrollIntoView
                    />
                    {cardEle.hasError && !cardEle?.dependentObj?.durationUnit && (
                      <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.DURATION_UNIT_REQ')}</span>
                    )}
                  </div>
                </div>
              </div>
            </Card.Body>
          )}
        </Card>
      </Accordion>
    </div>
  );
}
export default DependentAccordian;
